import '@material/web/dialog/dialog.js';
import { loopThroughElements } from "./utils/loop-through-elements";

export class PopupManager {
    popups: { [id: string]: HTMLDialogElement } = {};
    orphanedPopups: Array<HTMLDialogElement> = [];
    autoShowEnabled = true;

    constructor() {
        this.initialize();
    }

    initialize = () => {
        this.autoShowEnabled = !document.querySelector('[data-disable-auto-popups]');

        loopThroughElements(document.querySelectorAll('.mdc-dialog.mdc-dialog--auto-open'), (element) => {
            const dialogEl = element as HTMLDialogElement;

            const closeArray = dialogEl.getElementsByClassName('mdc-dialog__close');
            if (closeArray.length) {
                closeArray[0].addEventListener('click', () => {
                    dialogEl.close();
                });
            }

            if (this.autoShowEnabled) {
                if ('showModal' in dialogEl) {
                    dialogEl.showModal();
                } else {
                    (dialogEl as any).open = true; 
                }
            }

            if (dialogEl.id) {
                this.popups[dialogEl.id] = dialogEl;
            } else {
                this.orphanedPopups.push(dialogEl);
            }
        });
    }
}
